import React from 'react';
import styled, { keyframes } from 'styled-components';

const spinClockwise = keyframes`
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
`;

const spinCounterClockwise = keyframes`
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(-360deg); }
`;

const pulse = keyframes`
  0%, 100% { transform: translate(-50%, -50%) scale(0.85); opacity: 0.6; }
  50% { transform: translate(-50%, -50%) scale(1.15); opacity: 1; }
`;

const LoaderContainer = styled.div`
  position: ${props => props.position || 'fixed'};
  top: ${props => (props.position === 'relative' || props.position === 'static') ? 'auto' : (props.top || '50%')};
  left: ${props => (props.position === 'relative' || props.position === 'static') ? 'auto' : '50%'};
  transform: ${props => (props.position === 'relative' || props.position === 'static') ? 'none' : 'translate(-50%, -50%)'};
  width: 90px;
  height: 90px;
  margin: ${props => (props.position === 'relative' || props.position === 'static') ? 'auto' : '0'};
  z-index: 9999;
`;

const OuterRing = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 76px;
  height: 76px;
  border: 4.5px solid transparent;
  border-top-color: #3b82f6;
  border-bottom-color: #3b82f6;
  border-radius: 50%;
  animation: ${spinClockwise} 1.6s cubic-bezier(0.4, 0.1, 0.2, 0.9) infinite;
`;

const InnerRing = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  border: 3.5px solid transparent;
  border-left-color: #6366f1;
  border-right-color: #6366f1;
  border-radius: 50%;
  animation: ${spinCounterClockwise} 1.1s cubic-bezier(0.4, 0.1, 0.2, 0.9) infinite;
`;

const CenterDot = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 14px;
  height: 14px;
  background-color: #3b82f6;
  border-radius: 50%;
  box-shadow: 0 0 16px rgba(59, 130, 246, 0.8), 0 0 32px rgba(59, 130, 246, 0.4);
  animation: ${pulse} 1.8s ease-in-out infinite;
`;

const Loader = ({ position, top, className }) => {
  return (
    <LoaderContainer position={position} top={top} className={className}>
      <OuterRing />
      <InnerRing />
      <CenterDot />
    </LoaderContainer>
  );
};

export default Loader;
